export const validColors = ['blue', 'beige', 'green'] as const

export type ValidColor = (typeof validColors)[number]

export type CardType = {
  imageUrl: string
  title?: string
  description?: string
  url?: string
  linkText?: string
  extras?: {
    color?: ValidColor
  }
}

export type CategoryBannerProps = {
  className?: string
  cards?: CardType[]
}
